// extracted by mini-css-extract-plugin
export var teaser = "Teaser-module--teaser--aba7e";